import {Typography} from '@mui/material';
import React from 'react';

import {Modal} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {PendingDialogProps} from './types';

export function PendingDialog({open, text, onClose}: PendingDialogProps) {
	return (
		<Modal.Root
			slotProps={{
				paper: {
					sx: {
						height: 204,
						borderRadius: 1,
						maxWidth: 328,
						display: 'grid',
						placeItems: 'center',
						placeContent: 'center',
						padding: 2,
						width: '100%',
					},
				},
			}}
			open={open}
			onClose={onClose}>
			<Loading />
			<Typography mt={2} variant="subtitle1" color="primary">
				{text}
			</Typography>
		</Modal.Root>
	);
}
